module.exports = __webpack_public_path__ + "static/media/2_pl.bb906f3b.png";